module.exports = __webpack_public_path__ + "img/工业互联网.96816ff1.png";